<div class="eoi-container">
  <ng-container>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div (click)="openReject()">
        <div *ngIf="this.tabService.agencyIndex == 0">Total {{totalElements}} Agencies</div>
        <div *ngIf="this.tabService.agencyIndex == 1">Total {{pendingTotalElements}} Agencies</div>
        <div *ngIf="this.tabService.agencyIndex == 2">Total {{logTotalElements}} Agencies</div>
      </div>
      <mat-select [(ngModel)]="authorisedAgencyStatus" class="sort-select" (ngModelChange)="changeStatus(item)"
                  #item>
        <mat-option *ngFor="let item of selectList" [value]="item">{{ item }}</mat-option>
        <!-- <mat-option value="all">All</mat-option>
        <mat-option value="active">Active</mat-option>
        <mat-option value="suspend">Suspend</mat-option>
        <mat-option value="submitted">Submitted</mat-option>
        <mat-option value="approved">Approved</mat-option>
        <mat-option value="reject">Reject</mat-option>
        <mat-option value="removed">Removed</mat-option> -->
      </mat-select>
    </div>


    <div fxLayout="column" fxLayoutAlign="space-between" class="eoi-content">
      <mat-tab-group mat-align-tabs="start" style="width:100%" #childTabs class="projext-cooperation-tab"
                     [(selectedIndex)]="this.tabService.agencyIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            Authorised
            <!-- <span class="tab-count">{{totalElements}}</span> -->
          </ng-template>
          <ng-template matTabContent>
            <div style="margin-top:24px;background: #000;">
              <!-- <div fxLayout="row" fxLayoutGap="10px" style="background: #fff;padding: 16px 0">
                  <div style="position: relative;">
                      <div style="position: absolute; top: 7px; left: 5px">
                          <mat-icon style="color: #777779">
                              search　
                          </mat-icon>
                      </div>
                      <input class="find" placeholder="Search" [(ngModel)]="authorisedAgencyName"
                             #authorisedAgentSearch
                             (keypress)="$event.which === 13 ? searchAuthorisedAgencyList() : 0">
                  </div>
                  <div style="position: relative">
                      <select name="status" style="padding: 10px 0px 9px 60px;"
                              [(ngModel)]="authorisedAgencyStatus"
                              (change)="searchAuthorisedAgencyList()">
                          <option value="all">All</option>
                          <option value="active">Active</option>
                          <option value="suspend">Suspend</option>
                          <option value="remove">Removed</option>
                      </select>
                      <div style="position: absolute;top: 8px;left: 8px;">Status</div>
                  </div>
              </div> -->
              <div class="table-title">
                <div style="width: 25%;margin-left: 25px">Agency</div>
                <div style="width: 25%">Contact</div>
                <div style="width: 20%">Allocation</div>
                <div style="width: 10%">EOI</div>
                <div style="width: 20%">Status</div>
              </div>

              <div>
                <div *ngFor="let item of content;let i = index">
                  <div style="padding: 25px 24px;border-bottom:0.5px solid rgba(222, 222, 222, 0.2);">
                    <div class="card-title" style="position: relative">
                      <div
                        (click)="openAgency(item,i)"
                        style="display: flex;align-items: center;justify-content: start;width: 25%">
                        <img style="width: 24px;height: 24px;margin-right: 10px"
                             [src]="SERVER_URL + 'images/company_' + item.id +  '/' + item.logo">
                        <div>
                          <div class="name">{{ item.name }}</div>
                          <div class="address">{{ item.addressLine2 }}{{ item.addressLine1 ?
                            "," + item.addressLine1 : ''}}</div>
                        </div>
                      </div>
                      <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>
                      <div (click)="openAgency(item,i)" style="width: 25%">
                        <div class="name">{{ item.phoneNumber }}</div>
                        <div class="address">{{ item.email }}</div>
                      </div>
                      <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>
                      <div (click)="openAgency(item,i)" style="width: 20%" class="number">{{
                        item.propertyNumber }}
                        Properties allocated
                      </div>
                      <div style="width: 10%">
                        <mat-slide-toggle [checked]="item.enableEoi" [color]="'primary'"
                                          (change)="eoiChange($event,item)"></mat-slide-toggle>
                      </div>
                      <div style="width: 20%" (click)="openAgency(item,i)">
                        <!-- <button mat-button class="status" *ngIf="!item.showBtn"
                            [ngClass]="{ 'status-bg': item.status === 'SUSPEND'}"
                            (click)="item.showBtn = true">{{ item.status }}</button>
                        <div class="button-list" *ngIf="item.showBtn">
                            <button mat-button
                                (click)="updateStatus('suspend',item.id,item.name,item.showBtn )"
                                disabled="{{item.status === 'SUSPEND'}}">Suspend</button>
                            <button mat-button
                                (click)="updateStatus('active',item.id, item.name,item.showBtn)"
                                disabled="{{item.status === 'ACTIVE'}}">Active</button>
                        </div> -->

                        <button mat-button class="status" (click)="$event.stopPropagation()"
                                [ngClass]="{ 'status-bg': item.status === 'SUSPEND'}"
                                [matMenuTriggerFor]="menu" #menuTrigger>{{ item.status }}</button>
                        <mat-menu #menu="matMenu" class="operate_box2">
                          <button mat-menu-item
                                  (click)="updateStatus('active',item.id, item.name)"
                                  disabled="{{item.status === 'ACTIVE'}}">
                            <mat-icon style="color: #dedede;">check_circle</mat-icon>
                            <span>Active</span>
                          </button>
                          <button mat-menu-item
                                  (click)="updateStatus('suspend',item.id,item.name )"
                                  disabled="{{item.status === 'SUSPEND'}}">
                            <mat-icon style="color: #dedede;">pause_circle_filled</mat-icon>
                            <span>Suspend</span>
                          </button>
                          <button mat-menu-item
                                  (click)="updateStatus('remove',item.id,item.name )">
                            <mat-icon style="color: #dedede;">delete</mat-icon>
                            <span>Remove</span>
                          </button>
                        </mat-menu>
                      </div>
                      <mat-icon style="position: absolute;right: 0px;cursor: pointer"
                                *ngIf="agencyIndex == -1 || agencyIndex != i" (click)="openAgency(item,i)">
                        keyboard_arrow_down
                      </mat-icon>
                      <mat-icon style="position: absolute;right: 0px;cursor: pointer"
                                *ngIf="agencyIndex != -1 && agencyIndex == i" (click)="openAgency(item,i)">
                        keyboard_arrow_up
                      </mat-icon>
                    </div>
                  </div>
                  <div
                    style="padding: 24px;margin-bottom: 20px;border: 0.5px solid rgba(222, 222, 222, 0.2); border-radius: 3px;"
                    *ngIf="i === agencyIndex">
                    <div class="detail-info">
                      <div class="flex justify-start">
                        <div style="margin-right: 20px;padding: 10px 0;">
                          <div class="title">Total Commission</div>
                          <div class="value" *ngIf="commissionSetting.totalUnit === 1">
                            Rate {{ commissionSetting.total }}%
                          </div>
                        </div>
                        <div style="margin-right: 20px;padding: 10px 0;">
                          <div class="title">Commission allocation plan</div>
                          <div class="value">{{ commissionSetting.groupName }} Stage Payment
                          </div>
                        </div>
                        <div *ngFor="let res of allocationList">
                          <div class="card mr_20">
                            <img (click)="deleteAllocation(item,res.id,i)"
                                 src="./assets/images/delete.png" class="icon-img">
                            <div class="flex">
                              <div class="mr_10">{{ res.unitNum }}</div>
                              <div *ngIf="res.status === '0'">
                                <label style="margin-right: 8px;color: #74FF17">●
                                  Unavailable</label>
                              </div>
                              <div *ngIf="res.status === '1'">
                                <label style="margin-right: 8px;color: #74FF17">●
                                  Available</label>
                              </div>
                              <div *ngIf="res.status === '2'">
                                <label style="margin-right: 8px;color:#2589FE">●
                                  EOI</label>
                              </div>
                              <div *ngIf="res.status === '3'">
                                <label style="margin-right: 8px;color:#FFAA21">●
                                  Reserve</label>
                              </div>
                              <div *ngIf="res.status === '4'">
                                <label style="margin-right: 8px;color:#c99200">●
                                  Exchanage Conditional</label>
                              </div>
                              <div *ngIf="res.status === '5'">
                                <label style="margin-right: 8px;color:#9747FF">●
                                  Unconditional</label>
                              </div>
                              <div *ngIf="res.status === '6'">
                                <label style="margin-right: 8px;color:#909090">●
                                  Sold</label>
                              </div>
                            </div>
                            <div class="room">{{ res.bedRoom }}B/{{ res.bathRoom }}B/{{
                              res.carParking }}C
                            </div>
                            <div class="price">${{ res.price }}</div>

                          </div>
                        </div>

                      </div>
                      <div
                        style="max-width: fit-content; cursor: pointer;border-bottom: #2142FF 1px solid;color: #2142FF;"
                        (click)="openCommissionSettings(item.id,commissionSetting)">Edit
                        Commssion
                      </div>
                      <!-- <div class="body-title">Commission</div>
                      <div fxLayout="row" fxLayoutGap="16px" class="body-grid"
                           *ngIf="commissionSetting && commissionSetting.exist">
                          <div>
                              <div class="title">Total commission</div>
                              <div class="value" *ngIf="commissionSetting.totalUnit === 1">
                                  Rate {{ commissionSetting.total }}%
                              </div>
                              <div class="value"
                                   *ngIf="commissionSetting.totalUnit === 2">{{ commissionSetting.total | currency: '':'symbol':'3.0'}}</div>
                          </div>
                          <div>
                              <div class="title">Commission allocation plan</div>
                              <div class="value" *ngIf="commissionSetting.groupName === '1'">
                                  One-off Payment At
                                  Settlement
                              </div>
                              <div class="value" *ngIf="commissionSetting.groupName === '2'">Two-stage Payment</div>
                              <div class="value" *ngIf="commissionSetting.groupName === '3'">3
                                  Stages Payment
                              </div>
                          </div>
                      </div>
                      <button mat-button
                              (click)="openCommissionSettings(item.id,commissionSetting)"
                              class="header-button">
                          <mat-icon
                                  style="margin-right: 8px; width: 14px; height: 14px; font-size: 14px">
                              edit
                          </mat-icon>
                          Edit
                      </button> -->
                    </div>

                    <!-- <div *ngIf="allocationList.length>0">
                        <div class="body-title">Allocation</div>
                        <mat-grid-list cols="3" rowHeight="45px">
                            <mat-grid-tile *ngFor="let res of allocationList">
                                <div style="width: 100%;height: 100%;">
                                    <div class="allocation-grid">
                                        <div fxLayout="row" fxLayoutGap="16px">
                                            <div class="unitNum">{{ res.unitNum }}</div>
                                            <div *ngIf="res.status === '0'">
                                                <label style="margin-right: 8px;color: #03BC79">●</label>Unavailable
                                            </div>
                                            <div *ngIf="res.status === '1'">
                                                <label style="margin-right: 8px;color: #03BC79">●</label>Available
                                            </div>
                                            <div *ngIf="res.status === '2'">
                                                <label style="margin-right: 8px;color:#2589FE">●</label>EOI
                                            </div>
                                            <div *ngIf="res.status === '3'">
                                                <label style="margin-right: 8px;color:#FFC01D">●</label>Reserve
                                            </div>
                                            <div *ngIf="res.status === '4'">
                                                <label style="margin-right: 8px;color:#c99200">●</label>Exchanage Conditional
                                            </div>
                                            <div *ngIf="res.status === '5'">
                                                <label style="margin-right: 8px;color:#d3b977">●</label>Unconditional
                                            </div>
                                            <div *ngIf="res.status === '6'">
                                                <label style="margin-right: 8px;color:#909090">●</label>Sold
                                            </div>
                                        </div>
                                        <div fxLayout="row"
                                             style="display: flex;align-items: center">
                                            <div class="room">{{ res.bedRoom }}B {{ res.bathRoom }}
                                                B {{ res.carParking }}C
                                            </div>
                                            <div class="price">${{ res.price }}</div>
                                            <button mat-icon-button *ngIf="showDelete"
                                                    color="primary"
                                                    (click)="deleteAllocation(item,res.id,i)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <mat-divider style="width: 90%"></mat-divider>
                                </div>
                            </mat-grid-tile>
                        </mat-grid-list>
                        <div *ngIf="moreAllocationList && allocationList.length==9"
                             (click)="moreAllocation(true)" fxLayout="row"
                             fxLayoutAlign="center center"
                             style="margin: 20px 0;cursor: pointer;color: dodgerblue;text-decoration: underline">
                            More
                        </div>
                        <div *ngIf="moreAllocationList && allocationList.length>9"
                             (click)="moreAllocation(false)" fxLayout="row"
                             fxLayoutAlign="center center"
                             style="margin: 20px 0;cursor: pointer;color: dodgerblue;text-decoration: underline">
                            Hide
                        </div>
                        <button mat-button *ngIf="!showDelete" (click)="showDelete = !showDelete"
                                class="header-button">
                            <mat-icon
                                    style="margin-right: 8px; width: 14px; height: 14px; font-size: 14px">
                                edit
                            </mat-icon>
                            Edit allocation
                        </button>
                        <button mat-button *ngIf="showDelete" (click)="showDelete = !showDelete"
                                class="header-button">
                            <mat-icon
                                    style="margin-right: 8px; width: 14px; height: 14px; font-size: 14px">
                                clear
                            </mat-icon>
                            Cancel
                        </button>
                    </div> -->
                  </div>
                </div>
              </div>

              <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                             style="background: #000" [pageSizeOptions]="pageSizeOptions"
                             (page)="getSalesByPage(pageSize, $event)">
              </mat-paginator>

            </div>
          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            Pending
            <!-- <span class="tab-count">{{pendingTotalElements}}</span> -->
          </ng-template>
          <ng-template matTabContent>
            <div style="margin-top:24px;background: #000;">
              <!-- <div fxLayout="row" fxLayoutGap="10px" style="background: #fff;padding: 16px 0">
                  <div style="position: relative;">
                      <div style="position: absolute; top: 7px; left: 5px">
                          <mat-icon style="color: #777779">
                              search　
                          </mat-icon>
                      </div>
                      <input class="find" placeholder="Search" [(ngModel)]="pendingAgencyName"
                             (keypress)="$event.which === 13 ? searchPendingAgencyList() : 0">
                  </div>
              </div> -->

              <div class="table-title">
                <div style="width: 30%;margin-left: 25px">Agency</div>
                <div style="width: 30%">Contact</div>
                <div style="width: 20%">Status</div>
                <div style="width: 20%">Time</div>
              </div>

              <div>
                <div *ngFor="let item of pendingContent;let i = index" style="background: #000;">
                  <div style="padding: 25px 24px;border-bottom:1px solid rgba(222, 222, 222, 0.2)"
                       (click)="openPendingAgency(item,i)">
                    <div class="card-title" style="position: relative">
                      <div
                        style="display: flex;align-items: center;justify-content: start;width: 30%">
                        <img style="width: 24px;height: 24px;margin-right: 10px"
                             [src]="SERVER_URL + 'images/company_' + item.id +  '/' + item.logo">
                        <div>
                          <div class="name">{{ item.name }}</div>
                          <div class="address">{{ item.addressLine2 }}{{ item.addressLine1 ?
                            "," + item.addressLine1 : ''}}</div>
                        </div>
                      </div>
                      <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>
                      <div (click)="openPendingAgency(item,i)" style="width: 30%">
                        <div class="name">{{ item.phoneNumber }}</div>
                        <div class="address">{{ item.email }}</div>
                      </div>
                      <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>
                      <div style="width: 20%">
                        <button mat-button class="status-pending">{{ item.status }}</button>
                      </div>
                      <span style="color: rgba(222, 222, 222, 0.2);margin-right:12px;">|</span>
                      <div style="width: 20%" class="number">
                        {{ item.createTime | date:'HH:mm:ss dd/MM/yyyy' }}
                      </div>
                      <mat-icon style="position: absolute;right: 0px;cursor: pointer"
                                *ngIf="pendingAgencyIndex == -1 || pendingAgencyIndex != i"
                      (click)="eventTrack(item.name)">
                        keyboard_arrow_down
                      </mat-icon>
                      <mat-icon style="position: absolute;right: 0px;cursor: pointer"
                                *ngIf="pendingAgencyIndex != -1 && pendingAgencyIndex == i">
                        keyboard_arrow_up
                      </mat-icon>
                    </div>
                  </div>
                  <div style="padding: 0 24px 34px 24px;margin-bottom: 20px;background: #0E0D0D;"
                       *ngIf="i === pendingAgencyIndex">
                    <div>
                      <div class="msg-doc">
                        <div style="width: 45%">
                          <div class="title">Message</div>
                          <div class="msg">{{applyData.remark}}</div>
                        </div>
                        <div style="width: 45%">
                          <div class="title">Documents</div>
                          <ng-container *ngFor="let item of applyData.files">
                            <div class="files-grid" *ngIf="item.file">
                              <div fxLayout="row"
                                   style="margin-bottom: 5px;justify-content: space-between">
                                <div
                                  style="justify-content: space-between;display: flex">
                                  <mat-icon style="margin-right: 10px">
                                    insert_drive_file
                                  </mat-icon>
                                  <div>{{item.file ? item.file.fileName : null}}</div>
                                </div>
                                <div *ngIf="item.file"
                                     style="justify-content: space-between;display: flex">
                                  <!-- <mat-icon style="margin-right: 10px">remove_red_eye</mat-icon>-->
                                  <mat-icon
                                    (click)="previewApplyFile(item.file,applyData)">
                                    cloud_download
                                  </mat-icon>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <div class="commission-set">
                        <div>
                          <div fxLayout="row" style="align-items: center">
                            <div class="total-commission">Total Commission</div>
                            <mat-icon
                              style="font-size: 17px;color: #999999;display: flex;align-items: center">
                              info
                            </mat-icon>
                            <div class="tip">(The amount excluding GST)</div>
                          </div>
                          <div fxLayout="row">
                            <mat-form-field appearance="outline" class="no-padding"
                                            style="margin-right: 10px">
                              <mat-select [(ngModel)]="rate">
                                <mat-option [value]="1">Rate</mat-option>
                                <mat-option [value]="2">Fixed</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div style="position: relative">
                              <input id="total" class="input-style" [(ngModel)]="total"
                                     currencyMask (ngModelChange)="setValue()"
                                     [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2,min:0,max:99999999}">
                              <div class="sign" *ngIf="rate === 1">%</div>
                              <div class="sign" *ngIf="rate === 2">$</div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div>Choose One Commission Set</div>
                          <mat-form-field appearance="outline" class="no-padding">
                            <mat-select [(ngModel)]="groupName"
                                        (ngModelChange)="setValue()">
                              <mat-option [value]="'1'">Once-Off Payment At Settlement
                              </mat-option>
                              <mat-option [value]="'2'">Two-stage Payment</mat-option>
                              <mat-option [value]="'3'">3 Stages Payment</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div fxLayout="row">
                          <div>
                            <div>Stage1</div>
                            <div style="position: relative">
                              <input id="stage1" class="input-style"
                                     [readOnly]="groupName === '1'" [(ngModel)]="stageOne"
                                     currencyMask
                                     [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2}">
                              <div class="sign" *ngIf="rate === 1">%</div>
                              <div class="sign" *ngIf="rate === 2">$</div>
                            </div>
                          </div>
                          <div *ngIf="groupName != '1'">
                            <div>Stage2</div>
                            <div style="position: relative">
                              <input id="stage2" class="input-style"
                                     [(ngModel)]="stageTwo" currencyMask
                                     [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2}">
                              <div class="sign" *ngIf="rate === 1">%</div>
                              <div class="sign" *ngIf="rate === 2">$</div>
                            </div>
                          </div>
                          <div *ngIf="groupName == '3'">
                            <div>Stage3</div>
                            <div style="position: relative">
                              <input id="stage3" class="input-style"
                                     [(ngModel)]="stageThree" currencyMask
                                     [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2}">
                              <div class="sign" *ngIf="rate === 1">%</div>
                              <div class="sign" *ngIf="rate === 2">$</div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="notEqualError"
                             style="font-size: 14px; color: #d3442d; padding-top: 24px">
                          *The sum of each stage's commission must be equal to total
                          commission.
                        </div>

                        <div style="text-align: end;margin-top: 20px">
                          <button mat-button (click)="approve(item.name)"
                                  style="margin-right: 10px;color: #dedede;border: 1px solid #dedede;">
                            <mat-icon>done</mat-icon>
                            Approve
                          </button>
                          <button mat-button
                                  style="color: rgba(222, 222, 222, 0.4);border: 1px solid rgba(222, 222, 222, 0.4);"
                                  (click)="openReject(item.name)">
                            <mat-icon>clear</mat-icon>
                            Reject
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <mat-paginator [length]="pendingLength" [pageIndex]="pendingPageIndex"
                             [pageSize]="pendingPageSize" style="background: #000"
                             [pageSizeOptions]="pendingPageSizeOptions"
                             (page)="getPendingSalesByPage(pendingPageSize, $event)">
              </mat-paginator>
            </div>

          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            Log
            <!-- <span class="tab-count">{{logTotalElements}}</span> -->
          </ng-template>
          <ng-template matTabContent>
            <agencies-log [logData]="logData" [projectId]="project.id"></agencies-log>

          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </ng-container>
</div>
